export const LOG_PREFIX    = 'log';
export const BASE_ACTION   = 'baseAction';
export const ENTITY_PREFIX = 'entities';
